import React from "react";
import "./LaTribune.css";
import { useNavigate } from "react-router-dom";

const LaTribune = () => {
  const navigate = useNavigate();

  const links = [
    { name: "Journal", path: "/Journal" },
    { name: "Arts", path: "/Arts" },
    { name: "Musique", path: "/Musique" },
    { name: "Web Radio", path: "/WebRadio" },
    { name: "Cinéma", path: "/Cinema" }
  ];

  return (
    <div className="la-tribune-container">
      <h1 className="la-tribune-title">La Tribune - L'actualité des Clubs</h1>
      <div className="la-tribune-grid">
        {links.map((link, index) => (
          <div 
            key={index} 
            className="la-tribune-card"
            onClick={() => navigate(link.path)}
          >
            <h2 className="la-tribune-card-title">{link.name}</h2>
            <p className="la-tribune-card-link">Visiter</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LaTribune;
